import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { runbookStepActions } from "../../actions/runbookStep.actions";
import RunbookConnectorDropdown from "./RunbookConnectorDropdown";
import RunbookSystemDropdown from "./RunbookSystemDropdown";
import RunbookStepActionDropdown from "./RunbookStepActionDropdown";

const StepUpdateFormModal = ({
  stepId,
  show,
  onClose,
  user,
  runbookId,
  runbookGuid,
}) => {
  const dispatch = useDispatch();
  const stepList = useSelector((state) => state.runbookStep.response);
  const [step, setStep] = useState(null);

  const [formData, setFormData] = useState({
    action: "",
    condition: "",
    connectorId: "",
    filter: "",
    system: "",
    systemObject: "",
    dataSetPointer: "",
    stepDescription: "",
    fieldsToQuery: "",
  });

  useEffect(() => {
    if (show && stepId && stepList?.length > 0) {
      const currentStep = stepList.find((s) => s.stepNumber === stepId);
      if (currentStep) {
        setStep(currentStep);
        setFormData({
          stepId: currentStep.stepId,
          action: currentStep.action || "",
          condition: currentStep.condition || "",
          connectorId: currentStep.connector?.connectorId || "",
          filter: currentStep.filter || "",
          system: currentStep.system || "",
          systemObject: currentStep.systemObject || "",
          dataSetPointer: currentStep.dataSetPointer || "",
          stepDescription: currentStep.stepDescription || "",
          fieldsToQuery: currentStep.fieldsToQuery || "",
        });
      }
    }
  }, [show, stepId, stepList]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (step) {
      dispatch(
        runbookStepActions.update({
          ...formData,
          runbookId: runbookId,
          runbookGuid: runbookGuid,
        })
      );
      onClose();
    }
  };

  if (!step) return null;

  return (
    <Modal show={show} onHide={onClose} backdrop="static" size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Update Step {stepId}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Action</Form.Label>
            <RunbookStepActionDropdown
              value={formData.action}
              onChange={(value) =>
                setFormData((prev) => ({ ...prev, action: value }))
              }
              user={user}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Condition</Form.Label>
            <Form.Control
              name="condition"
              value={formData.condition}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Connector</Form.Label>
            <RunbookConnectorDropdown
              value={formData.connectorId}
              onChange={(value) =>
                setFormData((prev) => ({ ...prev, connectorId: value }))
              }
              user={user}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Filter</Form.Label>
            <Form.Control
              name="filter"
              value={formData.filter}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>System</Form.Label>
            <RunbookSystemDropdown
              value={formData.system}
              onChange={(value) =>
                setFormData((prev) => ({ ...prev, system: value }))
              }
              user={user}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>System Object</Form.Label>
            <Form.Control
              name="systemObject"
              value={formData.systemObject}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Data Set Pointer</Form.Label>
            <Form.Control
              name="dataSetPointer"
              value={formData.dataSetPointer}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Step Description</Form.Label>
            <Form.Control
              name="stepDescription"
              value={formData.stepDescription}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Fields To Query</Form.Label>
            <Form.Control
              name="fieldsToQuery"
              value={formData.fieldsToQuery}
              onChange={handleChange}
            />
          </Form.Group>

          <div className="text-end">
            <Button variant="secondary" onClick={onClose} className="me-2">
              Cancel
            </Button>
            <Button type="submit" variant="primary">
              Save Changes
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default StepUpdateFormModal;
